import {baseRequestService} from "../base.ts";

export const eventsEventIdApprovePost = (eventId: string) => baseRequestService({
    url: `/events/${eventId}/approve`,
    method: 'POST'
})